import util from '../lib/util';
import newHRTimestamp from '../lib/picos/timestamp';
import type {uuid, SchemaField, EntitySchema} from "../@types/schema";
import Base from "./base";
import {genUUID} from "../lib/picos/uuids";
import type {EntityType} from "../@types/entity";
function getCurrentUserId() { return sessionStorage.getItem('userId'); }
function getCurrentFirmId() { return sessionStorage.getItem('firmId'); }
export const Level = {
    Editor: "editor",
    Viewer: "viewer",
    FreeBusy: "freeBusy"
};
export type LevelType = typeof Level[keyof typeof Level];
class CalendarShare extends Base implements EntityType {
    calendarShareId: uuid;
    calendarId: uuid;
    userId: uuid;
    level: LevelType;
    constructor(doc: typeof CalendarShare | any) {
        super(doc);
        if (!doc) doc = {
            firmId: getCurrentFirmId(),
            addedBy: getCurrentUserId(),
            addedOn: newHRTimestamp(),
            status: "C",
            entityId: null,
            entityType: null,
            calendarShareId: genUUID(),
            calendarId: null,
            userId: null,
            level: "freeBusy",
        };
        // @ts-ignore
        this.entityId = doc._entityId || doc.entityId || doc.entityid || '00000000-0000-0000-0000-000000000000';
        // @ts-ignore
        this.entityType = doc._entityType || doc.entityType || doc.entitytype || "calendarShare";
        // @ts-ignore
        this.calendarShareId = doc._calendarShareId || doc.calendarShareId || doc.calendarshareid || genUUID();
        // @ts-ignore
        this.calendarId = doc._calendarId || doc.calendarId || doc.calendarid || null;
        // @ts-ignore
        this.userId = doc._userId || doc.userId || doc.userid || null;
        // @ts-ignore
        this.level = doc._level || doc.level || "freeBusy";
    }
    get id(): uuid { return this.calendarShareId; }
    static LEVEL_VALUES = ["editor", "viewer", "freeBusy"];
    static override getPkFields(): SchemaField[] { return [{"type":"uuid","required":true,"pk":true,"default":"__UUID__","comment":"Unique ID for the share"},{"type":"uuid","required":true,"pk":true,"base":true,"default":"__FIRM__","mergeStrategy":"immutable","comment":"Associated firm"}]; }
    toLowerCase() { return this.calendarShareId; }
    static override getNonRefArrayFields(): string[] { return []; }
    static override getDefaultEntries(): CalendarShare[] {
        return [];
    }
    static override getSchema(): EntitySchema {
        return Base.withBaseFields({
    entity: 'calendarShare',
    dataArea: 'Calendar',
    table: 'CALENDAR_SHARE',
    comment: `Shares one Calendar with one Firm User at a Sharing Level: editor (see and change entries), viewer (see full details) or freeBusy (see busy blocks only). A Firm User with no CalendarShare falls back to the Calendar's firmLevel. A Sharing Level limits detail and is not access control: Case Team, Restricted Case and Ethical Wall rules still apply.`,
    fields: {
        calendarShareId: {
            type: 'uuid', required: true, pk: true, default: '__UUID__', comment: 'Unique ID for the share'
        },
        calendarId: {
            type: 'uuid', required: true, entityType: 'calendar', comment: 'The Calendar being shared'
        },
        userId: {
            type: 'uuid', required: true, entityType: 'user', comment: 'The Firm User the Calendar is shared with'
        },
        level: {
            type: 'string',
            required: true,
            values: ['editor', 'viewer', 'freeBusy'],
            default: 'freeBusy',
            comment: 'The Sharing Level: editor, viewer (full details) or freeBusy (busy blocks only)'
        }
    },
    // No generic REST routes: they would list any Calendar and let a caller create an Editor share
    // for themselves. Hand-written routes arrive with the Access Model (OWA-1316).
    restRoutes: false,
    indexes: [
        {name: 'notDeleted', fn: t => t.status !== 'D'}
    ],
    maps: [
        {name: 'calendarId', keysFn: t => t.calendarId, presentFn: (t, k) => t.calendarId === k && t.status !== 'D'},
        {name: 'userId', keysFn: t => t.userId, presentFn: (t, k) => t.userId === k && t.status !== 'D'}
    ]
});
    }
}
export default CalendarShare;
